/**
 * VehicleTrackingModule - Root component for vehicle tracking module
 * 
 * Routes are relative to /vehicles
 * Access Control: Requires 'vehicle_tracking' feature
 */

import { Routes, Route } from 'react-router-dom';
import { ROLES } from '../../config/permissions';
import ProtectedRoute from '../../components/ProtectedRoute';
import FeatureGate from '../../components/FeatureGate';
import { useAuth } from '../../context/AuthContext';

// Vehicle Tracking Pages
import Vehicles from './pages/Vehicles';
import VehicleDetail from './pages/VehicleDetail';
import Repairs from './pages/Repairs';
import LiveVehicleView from './pages/LiveVehicleView';

export default function VehicleTrackingModule() {
  const { user } = useAuth();
  
  console.log('🚗 [VehicleTrackingModule] Rendering:', {
    hasUser: !!user,
    userRole: user?.role,
    isDeveloper: user?.isDeveloper,
    modulesAccess: user?.modulesAccess
  });
  
  return (
    <FeatureGate 
      user={user} 
      featureKey="vehicle_tracking"
      blur={true}
      showUpgradePrompt={true}
      upgradePlanName="Plus"
      customMessage="Vehicle tracking requires the Plus plan or higher. Contact your administrator to unlock this feature."
    >
      <Routes>
        {/* /vehicles/ → Vehicles List */}
        <Route 
          index 
          element={
            <ProtectedRoute 
              requiredRole={[ROLES.ADMIN, ROLES.USER]}
              redirectTo="/vehicles"
            >
              <Vehicles />
            </ProtectedRoute>
          } 
        />
        
        {/* /vehicles/live - Real-time telemetry view */}
        <Route 
          path="live" 
          element={
            <ProtectedRoute 
              requiredRole={[ROLES.ADMIN, ROLES.USER]}
              redirectTo="/vehicles"
            >
              <LiveVehicleView />
            </ProtectedRoute>
          } 
        />
        
        {/* /vehicles/:id → Vehicle Detail */}
        <Route 
          path=":id" 
          element={
            <ProtectedRoute 
              requiredRole={[ROLES.ADMIN, ROLES.USER]}
              redirectTo="/vehicles"
            >
              <VehicleDetail />
            </ProtectedRoute>
          } 
        />
        
        {/* /vehicles/repairs */}
        <Route 
          path="repairs" 
          element={
            <ProtectedRoute 
              requiredRole={[ROLES.ADMIN, ROLES.USER]}
              redirectTo="/vehicles"
            >
              <Repairs />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </FeatureGate>
  );
}

